import { render, staticRenderFns } from "./QuestionScreen.vue?vue&type=template&id=30bf80e4&scoped=true&lang=pug&"
import script from "./QuestionScreen.vue?vue&type=script&lang=js&"
export * from "./QuestionScreen.vue?vue&type=script&lang=js&"
import style0 from "./QuestionScreen.vue?vue&type=style&index=0&id=30bf80e4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf80e4",
  null
  
)

export default component.exports